module.exports = __webpack_public_path__ + "static/img/product12.91231c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product12.png
// module id = JCIe
// module chunks = 1